import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CheckoutAddress } from '@models';

export const ADDRESS_COUNTRY_CODE = 'US';

export const US_STATES: ReadonlyArray<{ code: string; name: string }> = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

const US_POSTAL_CODE_PATTERN = /^\d{5}(-\d{4})?$/;

export type AddressFormGroup = FormGroup<{
  addressLine1: FormControl<string>;
  city: FormControl<string>;
  stateCode: FormControl<string>;
  postalCode: FormControl<string>;
}>;

export function createAddressForm(): AddressFormGroup {
  return new FormGroup({
    addressLine1: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    city: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    stateCode: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    postalCode: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(US_POSTAL_CODE_PATTERN)],
    }),
  });
}

/** Fills the form with whatever is known; a state outside the list is left for the player to pick. */
export function patchAddressForm(form: AddressFormGroup, value: Partial<CheckoutAddress>): void {
  const stateCode = (value.stateCode ?? '').trim().toUpperCase();
  form.patchValue({
    addressLine1: value.addressLine1?.trim() ?? '',
    city: value.city?.trim() ?? '',
    stateCode: US_STATES.some((state) => state.code === stateCode) ? stateCode : '',
    postalCode: value.postalCode?.trim() ?? '',
  });
}

export function toCheckoutAddress(form: AddressFormGroup): CheckoutAddress {
  const value = form.getRawValue();
  return {
    addressLine1: value.addressLine1.trim(),
    city: value.city.trim(),
    stateCode: value.stateCode,
    postalCode: value.postalCode.trim(),
    country: ADDRESS_COUNTRY_CODE,
  };
}
